import { createWebHistory, createRouter } from 'vue-router';

const routes = [
    {
        path: '/in-app-view/cluster-info',
        name: 'in-app-cluster-info',
        component: () => import('@common/cluster-common').then(m => m.ClusterShareResult),
    },
    {
        path: '/in-app-view/trend-report',
        name: 'in-app-trend-report',
        component: () => import('@common/trend-report-common').then(m => m.MonthlyProReport),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 };
    },
});

export default router;
